// assets/theme.js
// Minimal theme JS — placeholder for cart drawer / mobile nav interactions.
// Native <details> handles the product accordion, so no JS required there.
function toggleMobileMenu() {
  var nav = document.getElementById('mobileNav');
  var overlay = document.getElementById('navOverlay');
  if (nav) nav.classList.toggle('open');
  if (overlay) overlay.classList.toggle('open');
}

document.addEventListener('DOMContentLoaded', function () {
  console.log('Alialvibaba theme loaded');
});